var map = {
	"./actual-date.json": 1090,
	"./ar.json": 3746,
	"./cs.json": 5607,
	"./de.json": 8909,
	"./el.json": 8384,
	"./en.json": 3074,
	"./es.json": 5441,
	"./fr.json": 505,
	"./hi.json": 5634,
	"./id.json": 6644,
	"./it.json": 4660,
	"./ja.json": 8256,
	"./kk.json": 1831,
	"./ms.json": 8153,
	"./nb.json": 7457,
	"./nl.json": 4595,
	"./pl.json": 6097,
	"./pt-br.json": 3444,
	"./ru.json": 3796,
	"./sv.json": 5032,
	"./th.json": 41,
	"./tr.json": 9815,
	"./uk.json": 1145,
	"./uz.json": 3438,
	"./vi.json": 2452,
	"./zh-CN.json": 3831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7934;